import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-collection-landing',
  templateUrl: './collection-landing.component.html'
})
export class CollectionLandingComponent implements OnInit {
  collectionId: any;
  constructor(private router: Router, private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.collectionId = this.activatedRoute.snapshot.paramMap.get('id');
    if (!this.collectionId || this.collectionId === 0) { this.router.navigate(['/login']) }
  }
}
